import { useState, useCallback } from 'react';

export function useFailedImageIds() {
  const [failedIds, setFailedIds] = useState<Set<string>>(new Set());
  const markFailed = useCallback(
    (id: string) => setFailedIds((prev) => new Set(prev).add(id)),
    []
  );
  const hasFailed = useCallback(
    (id: string) => failedIds.has(id),
    [failedIds]
  );
  return { failedIds, markFailed, hasFailed };
}
